module.exports = __webpack_public_path__ + "static/media/upload-svgrepo-com 1.27e74e72.svg";